<template>
  <div class="Sobre" v-if="!is_mobile">
    <div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
      <headNav :activeNav="'sobre'"></headNav>
    </div>
    <div class="eshoy_content_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'sobre'"></homeNav>
      </div>

      <div class="libe_home_banner">
        <div class="libe_home_banner_img">
          <img src="../assets/imgs/about_banner01.jpg" alt="">
        </div>
      </div>

        <div class="plabout_wrap">
            <div class="plabout_cont">
                <img src="../assets/imgs/about_01.png" alt="">
            </div>
            <div class="plabout_cont">
                <img src="../assets/imgs/about_02_new.png" alt="">
            </div>
            <div class="plabout_cont">
                <img src="../assets/imgs/about_03.png" alt="">
            </div>
        </div>

    </div>
    <footPage></footPage>
  </div>
  <div v-else class="mobile_viewrap">
      <div class="mobile_wrap">
          <mobNav :activeNav="activeNav"></mobNav>
      </div>
      <div class="mobhome_banner">
          <div class="mobhome_banner_cont">
              <img src="@/assets/mobimg/mob_about01.png" />
          </div>
      </div>
      <div class="mobile_itemimg_wrap">
          <div class="mobile_itemimg_view">
              <img src="@/assets/mobimg/mob_about_01.png" alt="">
          </div>
          <div class="mobile_itemimg_view">
              <img src="@/assets/mobimg/mob_about_02_new.png" alt="">
          </div>
          <div class="mobile_itemimg_view">
              <img src="@/assets/mobimg/mob_about_03.png" alt="">
          </div>
      </div>
      <mobFooter></mobFooter>
   </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/sobre.scss";
import mobNav from "@/components/mobNav.vue";
import mobFooter from "@/components/mobfooter.vue";
import mobileOrpc from "@/mixins/index";

export default {
    name: "Sobre",
    components: { headNav, homeNav, footPage, mobNav, mobFooter },
    mixins: [mobileOrpc],
    data() {
      return {
        activeNav: "sobre",
        scroll: 0,
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop=0;
    },
    methods: {
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>
  .eshoy_about_wrap{
    width: 100%;
    height: auto;
    padding: 90px 0 140px 0;
    background: #FBF9F9;
  }
  .eshoy_abtitle_cont{
    width: 100%;
    height: auto;
    padding-bottom: 80px;
  }
  .eshoy_abtitle_icon{
    width: 54px;
    height: 54px;
    margin: 0 auto;
  }
  .eshoy_abtitle_view{
    width: 100%;
    height: 30px;
    padding-top: 18px;
    font-size: 30px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #391C10;
    line-height: 30px;
    text-align: center;
  }
  .eshoy_abtitle_icon img{
    display: block;
    width: 100%;
  }
  .eshoy_abmessage_cont{
    width: 1200px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.04);
    border-radius: 20px;
    border: 1px solid #EFECEA;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 63px 64px 65px 64px;
  }
  .eshoy_abmessage_title{
    width: 100%;
    height: 22px;
    font-size: 22px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
    color: #453D39;
    line-height: 22px;
  }
  .eshoy_abmessage_view{
    width: 100%;
    height: auto;
    padding-top: 24px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 400;
    color: #453D39;
    line-height: 33px;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .eshoy_content_wrap{
    width: 100%;
    height: auto;
    position: relative;
  }
  .plabout_wrap{
      width: 100%;
      height: auto;
      background: #13151A;
      padding-top: 120px;
  }
  .plabout_cont{
      width: 1200px;
      height: auto;
      padding-bottom: 120px;
      margin: 0 auto;
  }
  .plabout_cont img{
      display: block;
      width: 100%;
  }
</style>
